import React from 'react';
import { Icon } from './Icon.js';
export const IconPinFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M6 0C3.2432 0 1 2.28523 1 5.09473C1 8.78423 4.4561 11.539 5.7695 11.9638C5.8442 11.9882 5.9223 11.9999 6 11.9999C6.0777 11.9999 6.1558 11.9882 6.2305 11.9638C7.544 11.539 11 8.78413 11 5.09473C11 2.28513 8.7568 0 6 0ZM6 6.5C5.1729 6.5 4.5 5.8271 4.5 5C4.5 4.1729 5.1729 3.5 6 3.5C6.8271 3.5 7.5 4.1729 7.5 5C7.5 5.8271 6.8271 6.5 6 6.5Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconPinFill12.js.map